var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.barData.title,"left-text":_vm.barData.leftText,"left-arrow":_vm.barData.leftArrow},on:{"click-left":function($event){return _vm.$emit('handleLeft')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }